import { TotadminPermission } from 'data/__generated__';

import { SectionColumn, SectionContainer } from 'components/DetailsView/Section';

import { PaymentsSection } from './PaymentsSection';

// Les paiements faits avec une subvention, un rituel ou une formule, sur leur propre fiche. Repliée et montée à la
// première ouverture : une subvention d'entreprise couvre des milliers de transactions.
export const PaymentMethodPaymentsSection = ({
    paymentMethodId,
    emptyMessage,
    dataTest,
}: {
    paymentMethodId: string;
    emptyMessage: string;
    dataTest: string;
}) => (
    <SectionContainer title="Paiements" lazy requiredPermissions={[TotadminPermission.TransactionsRead]}>
        <SectionColumn>
            <PaymentsSection
                scope={{ paymentMethodIds: [paymentMethodId] }}
                emptyMessage={emptyMessage}
                dataTest={dataTest}
            />
        </SectionColumn>
    </SectionContainer>
);
